import { StdResponse, request } from "@/global/config/request";
import { RsProjectGlobalDataBox } from "@/global/interface/project-device/project-data-box";

export function getProjectDataBoxes(projectId: number, type: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/project-global-data-boxes`, {
        params: {
            ...params,
            type: type,
        }
    })
}

export function createProjectGDataBoxes(data: RsProjectGlobalDataBox[], params?: {}): Promise<StdResponse<any>> {
    return request.post(`/project-global-data-boxes`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteProjectGDataBox(projectId: number, globalDataBoxId: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/project-global-data-boxes/delete`, {
        params: {
            ...params,
            projectId: projectId,
            globalDataBoxId: globalDataBoxId,
        }
    })
}   